// extracted by mini-css-extract-plugin
export var button = "_f8-0";
export var donut = "_f8-1";
export var donutFill = "_f8-3";
export var donutTrack = "_f8-2";